export default "__VITE_ASSET__BUpfPJ6h__"